import {
    Box,
    Text,
    Badge,
    SimpleGrid,
    Image,
    Flex,
} from "@chakra-ui/react";

import AppDrawer from "../../../components/AppDrawer";

const BASE_URL =
    process.env
        .REACT_APP_API_BASE_URL;

const TicketDetailsDrawer = ({
    ticket,
    open,
    onClose,
}) => {
    if (!ticket) return null;

    const getStatusStyles = (
        status
    ) => {
        switch (status) {
            case "OPEN":
                return {
                    bg: "#DBEAFE",
                    color: "#1D4ED8",
                };

            case "IN_PROGRESS":
                return {
                    bg: "#FEF3C7",
                    color: "#B45309",
                };

            case "RESOLVED":
                return {
                    bg: "#DCFCE7",
                    color: "#15803D",
                };

            case "CLOSED":
                return {
                    bg: "#F3F4F6",
                    color: "#6B7280",
                };

            default:
                return {
                    bg: "#F3F4F6",
                    color: "#6B7280",
                };
        }
    };

    return (
        <AppDrawer
            open={open}
            onClose={onClose}
            title=""
        >
            <Box>
                <Text
                    fontSize="12px"
                    fontWeight="600"
                    color="#6366F1"
                    mb={2}
                >
                    #
                    {ticket.ticket_id?.slice(
                        0,
                        8
                    )}
                </Text>

                <Text
                    fontSize="24px"
                    fontWeight="700"
                    color="#1E293B"
                    lineHeight="1.3"
                    mb={5}
                >
                    {
                        ticket.subject
                    }
                </Text>

                <Flex
                    gap={2}
                    mb={8}
                    wrap="wrap"
                >
                    <Badge
                        bg={
                            getStatusStyles(
                                ticket.status
                            ).bg
                        }
                        color={
                            getStatusStyles(
                                ticket.status
                            ).color
                        }
                    >
                        {
                            ticket.status
                        }
                    </Badge>

                    <Badge
                        bg="#F1F5F9"
                        color="#475569"
                    >
                        {
                            ticket.category
                        }
                    </Badge>
                </Flex>

                <Text
                    fontSize="11px"
                    fontWeight="600"
                    color="#64748B"
                    textTransform="uppercase"
                    mb={2}
                >
                    Description
                </Text>

                <Text
                    fontSize="14px"
                    color="#475569"
                    lineHeight="24px"
                    whiteSpace="pre-wrap"
                    mb={8}
                >
                    {
                        ticket.message
                    }
                </Text>

                {ticket.admin_notes && (
                    <>
                        <Text
                            fontSize="11px"
                            fontWeight="600"
                            color="#64748B"
                            textTransform="uppercase"
                            mb={2}
                        >
                            Admin Notes
                        </Text>

                        <Box
                            p={4}
                            mb={8}
                            bg="#EFF6FF"
                            border="1px solid"
                            borderColor="#BFDBFE"
                            borderRadius="12px"
                        >
                            <Text
                                fontSize="14px"
                                color="#1E40AF"
                            >
                                {
                                    ticket.admin_notes
                                }
                            </Text>
                        </Box>
                    </>
                )}

                {!!ticket
                    .documents
                    ?.length && (
                    <>
                        <Text
                            fontSize="11px"
                            fontWeight="600"
                            color="#64748B"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Attachments
                        </Text>

                        <SimpleGrid
                            columns={2}
                            gap={3}
                        >
                            {ticket.documents.map(
                                (
                                    doc
                                ) => (
                                    <Box
                                        key={
                                            doc.document_id
                                        }
                                        border="1px solid"
                                        borderColor="#E2E8F0"
                                        borderRadius="10px"
                                        overflow="hidden"
                                    >
                                        <Image
                                            src={`${BASE_URL}/${doc.file_path}`}
                                            h="180px"
                                            w="100%"
                                            objectFit="cover"
                                        />

                                        <Box
                                            p={
                                                2
                                            }
                                        >
                                            <Text
                                                fontSize="12px"
                                                color="#475569"
                                                noOfLines={
                                                    1
                                                }
                                            >
                                                {doc.file_path
                                                    ?.split(
                                                        "/"
                                                    )
                                                    .pop()}
                                            </Text>
                                        </Box>
                                    </Box>
                                )
                            )}
                        </SimpleGrid>
                    </>
                )}
            </Box>
        </AppDrawer>
    );
};

export default TicketDetailsDrawer;